// extracted by mini-css-extract-plugin
export default {"container":"UaitlH","text":"UaoX0V","buttonContainer":"dpTOHk"};